export default __webpack_public_path__ + "static/media/ennergyAssetTypeIcon.ac4c3b71.svg";